export const code_trigger_type = [
  {
    id: 1,
    code: "button",
    description: "Button",
  },
  {
    id: 2,
    code: "timeout",
    description: "Time Out",
  },
  {
    id: 3,
    code: "next",
    description: "Next",
  },
];
